<template>
  <section class="customer-quotes-item">
    <img src="/img/icons/quotes.svg" :alt="$t('quotes.icon')" />
    <div class="container">
      <p>{{ quote }}</p>
      <p class="p2">{{ customer }}</p>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    quote: String,
    customer: String,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';

.customer-quotes-item {
  height: 165px;
  max-width: 335px;
  border: 0.5px solid $light-grey;
  border-radius: $border-radius;
  box-shadow: 0 0 12px 0 rgba(235, 239, 253, 0.8);
  margin: 0 8px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
}
.container {
  height: 100%;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.p2 {
  color: $grey;
  font-size: $font-size-base;
  font-style: italic;
  letter-spacing: 0.15px;
  line-height: 24px;
}
</style>
